/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc
 */
import * as References from './StandardizedInstallTypeRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc#getStandardizedInstallType
 */
export const GET_STANDARDIZED_INSTALL_TYPE_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallTypeRpc_getStandardizedInstallType';
export const GET_STANDARDIZED_INSTALL_TYPE_QUERY: RegisteredQuery<
  'result',
  References.GetStandardizedInstallTypeRequestType,
  References.GetStandardizedInstallTypeResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_STANDARDIZED_INSTALL_TYPE_QUERY_FIELD_NAME,
  args: ['listingId', 'published'],
  fetcher(
    request: References.GetStandardizedInstallTypeRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetStandardizedInstallTypeResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getStandardizedInstallTypeRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc#getStandardizedInstallTypeFromNa1
 */
export const GET_STANDARDIZED_INSTALL_TYPE_FROM_NA1_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallTypeRpc_getStandardizedInstallTypeFromNa1';
export const GET_STANDARDIZED_INSTALL_TYPE_FROM_NA1_QUERY: RegisteredQuery<
  'result',
  References.GetStandardizedInstallTypeFromNa1RequestType,
  References.GetStandardizedInstallTypeFromNa1ResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_STANDARDIZED_INSTALL_TYPE_FROM_NA1_QUERY_FIELD_NAME,
  args: ['listingId', 'published'],
  fetcher(
    request: References.GetStandardizedInstallTypeFromNa1RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetStandardizedInstallTypeFromNa1ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getStandardizedInstallTypeFromNa1Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc#updateStandardizedInstallTypeForDraftListing
 */
export const UPDATE_STANDARDIZED_INSTALL_TYPE_FOR_DRAFT_LISTING_MUTATION_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallTypeRpc_updateStandardizedInstallTypeForDraftListing';
export const UPDATE_STANDARDIZED_INSTALL_TYPE_FOR_DRAFT_LISTING_MUTATION: RegisteredQuery<
  'result',
  References.UpdateStandardizedInstallTypeForDraftListingRequestType,
  References.UpdateStandardizedInstallTypeForDraftListingResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName:
    UPDATE_STANDARDIZED_INSTALL_TYPE_FOR_DRAFT_LISTING_MUTATION_FIELD_NAME,
  args: ['listingId', 'installType', 'callerPortalId'],
  fetcher(
    request: References.UpdateStandardizedInstallTypeForDraftListingRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateStandardizedInstallTypeForDraftListingResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateStandardizedInstallTypeForDraftListingRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
